import { useState, useRef, useMemo } from 'react';
import axios from 'axios';
import NavHeader from '../shared/Nav-Header';
import ProjectNetworkMessages from './all Messages/PN';
import PromotionMessages from './all Messages/PM';
import RecruiterMessages from './all Messages/RM';
import GroupMessages from './all Messages/GM';
import styles from './allMessages.module.css';
import { io } from 'socket.io-client';

const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-a1b2.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true // Important for CORS with credentials
});

const AllMessages = () => {
    const [activeChat1, setActiveChat1] = useState(null);
    const [activeChat2, setActiveChat2] = useState(null);
    const [activeChat3, setActiveChat3] = useState(null);
    const [activeChat4, setActiveChat4] = useState(null);
    const [messages, setMessages] = useState([]);
    const [userId, setUserId] = useState('');
    const [recentMessage, setRecentMessage] = useState('');
    const [showOptions, setShowOptions] = useState(null);
    const [currentRoomId, setCurrentRoomId] = useState('');
    const [group, setGroup] = useState({});
    const [newMessage, setNewMessage] = useState('');
    
    const bottomRef = useRef(null);
    const token = useMemo(() => localStorage.getItem('token'), []);

    const handleProfileClick1 = (profile) => {
        setActiveChat1(profile);
    };
    const handleProfileClick2 = (profile) => {
        setActiveChat2(profile);
    };
    const handleProfileClick3 = (profile) => {
        setActiveChat3(profile);
    };
    const handleProfileClick4 = (profile) => {
        setActiveChat4(profile);
    };
    const sendMessage1 = async () => {
        setRecentMessage('');

        if (!recentMessage.trim() || !currentRoomId || !userId || !activeChat1?._id) {
            console.error("Missing required fields:", { currentRoomId, userId, activeChat1, recentMessage });
            return;
        }

        try {
            const receiverId = activeChat1._id;

            const requestData = {
                roomId: currentRoomId,
                senderId: userId,
                receiverId,
                message: recentMessage
            };

            const response = await axios.post('/api/applicant-to-recruiter-message/send-message', requestData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                const newMessage = response.data.newMessage;
                socket.emit('sendMessage', newMessage);
                setMessages((prevMessages) => [...prevMessages, newMessage]);
            }
        } catch (error) {
            console.error("Error sending message:", error.response?.data || error.message);
        }
    };

    const handleDeleteMessageForAll1 = async (messageId) => {
        try {
            await axios.post('/api/applicant-to-recruiter-message/delete-message-for-all', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting message for all:', error);
        }
    };

    const handleDeleteMessageForMe1 = async (messageId) => {
        try {
            await axios.post('/api/applicant-to-recruiter-message/delete-message-for-me', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting message for me:', error);
        }
    };

    const handleMarkRead1 = async (messageId) => {
        try {
            await axios.post('/api/applicant-to-recruiter-message/mark-read', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.map(msg => {
                if (msg._id === messageId) {
                    return { ...msg, readBy: [...msg.readBy, { userId, readAt: new Date() }] };
                }
                return msg;
            }));
        } catch (error) {
            console.error('Error marking message as read:', error);
        }
    };

    const sendMessage2 = async () => {
        if (!recentMessage.trim()) return;
        setRecentMessage('');
        try {
            const response = await axios.post('/api/group/send-group-message', {
                groupId: group._id,
                senderId: userId,
                message: newMessage
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setMessages((prevMessages) => [...prevMessages, response.data.message]);
                setNewMessage('');
            }
        } catch (error) {
            console.error('Error sending group message:', error);
        }
    };

    const handleDeleteMessageForMe2 = async (messageId, forEveryone) => {
        try {
            await axios.post('/api/group/delete-group-message', {
                messageId,
                forEveryone
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
            setShowOptions(null)
        } catch (error) {
            console.error('Error deleting group message:', error);
        }
    };

    const handleMarkRead2 = async (messageId) => {
        try {
            await axios.post('/api/group/mark-group-message-read', {
                messageId
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setMessages((prevMessages) => prevMessages.map(msg => {
                if (msg._id === messageId) {
                    return { ...msg, readBy: [...msg.readBy, { userId, readAt: new Date() }] };
                }
                return msg;
            }));
        } catch (error) {
            console.error('Error marking group message as read:', error);
        }
    };

    const handleDeleteMessageForAll2 = async (messageId) => {
        try {
            await axios.post('/api/group/delete-group-message-for-all', {
                messageId
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting group message for all:', error);
        }
    };

    const handleMarkRead3 = async (messageId) => {
        try {
            await axios.post('/api/recruiter-to-applicant-message/mark-read', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.map(msg => {
                if (msg._id === messageId) {
                    return { ...msg, readBy: [...msg.readBy, { userId, readAt: new Date() }] };
                }
                return msg;
            }));
        } catch (error) {
            console.error('Error marking message as read:', error);
        }
    };

    const sendMessage3 = async () => {
        if (!recentMessage.trim()) return;
        setRecentMessage('');
        try {
            const response = await axios.post('/api/recruiter-to-applicant-message/send-message', {
                roomId: currentRoomId,
                senderId: userId,
                receiverId: activeChat3._id,
                message: recentMessage

            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            if (response.data.success) {
                const newMessage = response.data.newMessage;
                socket.emit('sendMessage', newMessage);
                setMessages((prevMessages) => [...prevMessages, newMessage]);
            }
        } catch (error) {
            // console.log("Error sending message:", error.response?.data || error.message);
        }
    };

    const handleDeleteMessageForMe3 = async (messageId) => {
        try {
            await axios.post('/api/recruiter-to-applicant-message/delete-message-for-me', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting message for me:', error);
        }
    };

    const handleDeleteMessageForAll3 = async (messageId) => {
        try {
            await axios.post('/api/recruiter-to-applicant-message/delete-message-for-all', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting message for all:', error);
        }
    };
    



    const formatDate = (date) => {
        const d = new Date(date);
        const now = new Date();
        const isThisYear = d.getFullYear() === now.getFullYear();
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear().toString().slice(-2);
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return isThisYear ? `${hours}:${minutes} ${day}/${month}` : `${hours}:${minutes} ${day}/${month}/${year}`;
    };

    return (
        <>            
        <NavHeader />
        <div className={styles.container}>
            <div className={styles.topLeft}>
                <ProjectNetworkMessages onProfileClick={handleProfileClick1} />
            </div>
            <div className={styles.topRight}>
                <GroupMessages onProfileClick={handleProfileClick2} />
            </div>
            <div className={styles.bottomLeft}>
                <RecruiterMessages onProfileClick={handleProfileClick3} />
            </div>
            <div className={styles.bottomRight}>
                <PromotionMessages onProfileClick={handleProfileClick4} />
            </div>
            {activeChat1 && (
                <div className={styles.chatPopup}>
                    <div className={styles.chatHeader}>
                        <img 
                            src={activeChat1.profilePicture ? activeChat1.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                            alt={activeChat1.name} className={styles.profilePictureHeader}
                            />
                        <h3>{activeChat1.name}</h3>
                        <button onClick={() => setActiveChat1(null)}>Close</button>
                    </div>
                    {/* from here copied */}
                    <div className={styles.chatBody}>
                        <div className={styles.chatBox}>
                                <div className={styles.messagesContainer}>
                                    {messages.map((msg, index) => (
                                        <div key={index} className={`${styles.message} ${msg.senderId === userId ? styles.sent : styles.received}`}>
                                            <div className={styles.messageContent}>
                                                {msg.message}
                                                <button className={styles.messageOptionsButton} onClick={() => setShowOptions(showOptions === index ? null : index)}>⋮</button>
                                                {showOptions === index && (
                                                    <div className={styles.messageOptionsMenu}>
                                                        <button onClick={() => {handleMarkRead1(msg._id);setShowOptions(null)}}>Read by</button>
                                                        <button onClick={() => {handleDeleteMessageForMe1(msg._id);setShowOptions(null);}}>Delete for me</button>
                                                        {msg.senderId === userId && (
                                                            <button onClick={() => {handleDeleteMessageForAll1(msg._id);setShowOptions(null)}}>Delete for everyone</button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={styles.messageTimestamp}>
                                                {formatDate(msg.createdAt)}
                                            </div>
                                        </div>
                                    ))}
                                    <div ref={bottomRef} />
                                </div>
                            </div>
                            <div className={styles.inputBox}>
                                <input
                                    type="text"
                                    value={recentMessage}
                                    onChange={(e) => setRecentMessage(e.target.value)}
                                    placeholder="Type a message..."
                                />
                                <button onClick={sendMessage1}>Send</button>
                            </div>
                            {/* end here copied */}
                     </div>
                    </div>
            )}

            {activeChat2 && (
                <div className={styles.chatPopup}>
                    <div className={styles.chatHeader}>
                        <img 
                            src={activeChat2.profilePicture ? activeChat2.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                            alt={activeChat2.name} className={styles.profilePictureHeader}
                            />
                        <h3>{activeChat2.name}</h3>
                        <button onClick={() => setActiveChat2(null)}>Close</button>
                    </div>
                    {/* from here copied */}
                    <div className={styles.chatBody}>
                        <div className={styles.chatBox}>
                                <div className={styles.messagesContainer}>
                                    {messages.map((msg, index) => (
                                        <div key={index} className={`${styles.message} ${msg.senderId === userId ? styles.sent : styles.received}`}>
                                            <div className={styles.messageContent}>
                                                {msg.message}
                                                <button className={styles.messageOptionsButton} onClick={() => setShowOptions(showOptions === index ? null : index)}>⋮</button>
                                                {showOptions === index && (
                                                    <div className={styles.messageOptionsMenu}>
                                                        <button onClick={() => {handleMarkRead2(msg._id);setShowOptions(null)}}>Read by</button>
                                                        <button onClick={() => {handleDeleteMessageForMe2(msg._id);setShowOptions(null);}}>Delete for me</button>
                                                        {msg.senderId === userId && (
                                                            <button onClick={() => {handleDeleteMessageForAll2(msg._id);setShowOptions(null)}}>Delete for everyone</button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={styles.messageTimestamp}>
                                                {formatDate(msg.createdAt)}
                                            </div>
                                        </div>
                                    ))}
                                    <div ref={bottomRef} />
                                </div>
                            </div>
                            <div className={styles.inputBox}>
                                <input
                                    type="text"
                                    value={recentMessage}
                                    onChange={(e) => setRecentMessage(e.target.value)}
                                    placeholder="Type a message..."
                                />
                                <button onClick={sendMessage2}>Send</button>
                            </div>
                            {/* end here copied */}
                     </div>
                    </div>
            )}

            {activeChat3 && (
                <div className={styles.chatPopup}>
                    <div className={styles.chatHeader}>
                        <img 
                            src={activeChat3.profilePicture ? activeChat3.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                            alt={activeChat3.name} className={styles.profilePictureHeader}
                            />
                        <h3>{activeChat3.name}</h3>
                        <button onClick={() => setActiveChat3(null)}>Close</button>
                    </div>
                    {/* from here copied */}
                    <div className={styles.chatBody}>
                        <div className={styles.chatBox}>
                                <div className={styles.messagesContainer}>
                                    {messages.map((msg, index) => (
                                        <div key={index} className={`${styles.message} ${msg.senderId === userId ? styles.sent : styles.received}`}>
                                            <div className={styles.messageContent}>
                                                {msg.message}
                                                <button className={styles.messageOptionsButton} onClick={() => setShowOptions(showOptions === index ? null : index)}>⋮</button>
                                                {showOptions === index && (
                                                    <div className={styles.messageOptionsMenu}>
                                                        <button onClick={() => {handleMarkRead3(msg._id);setShowOptions(null)}}>Read by</button>
                                                        <button onClick={() => {handleDeleteMessageForMe3(msg._id);setShowOptions(null);}}>Delete for me</button>
                                                        {msg.senderId === userId && (
                                                            <button onClick={() => {handleDeleteMessageForAll3(msg._id);setShowOptions(null)}}>Delete for everyone</button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={styles.messageTimestamp}>
                                                {formatDate(msg.createdAt)}
                                            </div>
                                        </div>
                                    ))}
                                    <div ref={bottomRef} />
                                </div>
                            </div>
                            <div className={styles.inputBox}>
                                <input
                                    type="text"
                                    value={recentMessage}
                                    onChange={(e) => setRecentMessage(e.target.value)}
                                    placeholder="Type a message..."
                                />
                                <button onClick={sendMessage3}>Send</button>
                            </div>
                            {/* end here copied */}
                     </div>
                    </div>
            )} 

            {/* {activeChat4 && (
                <div className={styles.chatPopup}>
                    <div className={styles.chatHeader}>
                        <img 
                            src={activeChat4.profilePicture ? activeChat4.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                            alt={activeChat4.name} className={styles.profilePictureHeader}
                            />
                        <h3>{activeChat4.name}</h3>
                        <button onClick={() => setActiveChat4(null)}>Close</button>
                    </div>
                    <div className={styles.chatBody}>
                        <div className={styles.chatBox}>
                                <div className={styles.messagesContainer}>
                                    {messages.map((msg, index) => (
                                        <div key={index} className={`${styles.message} ${msg.senderId === userId ? styles.sent : styles.received}`}>
                                            <div className={styles.messageContent}>
                                                {msg.message}
                                                <button className={styles.messageOptionsButton} onClick={() => setShowOptions(showOptions === index ? null : index)}>⋮</button>
                                                {showOptions === index && (
                                                    <div className={styles.messageOptionsMenu}>
                                                        <button onClick={() => {handleMarkRead4(msg._id);setShowOptions(null)}}>Read by</button>
                                                        <button onClick={() => {handleDeleteMessageForMe4(msg._id);setShowOptions(null);}}>Delete for me</button>
                                                        {msg.senderId === userId && (
                                                            <button onClick={() => {handleDeleteMessageForAll4(msg._id);setShowOptions(null)}}>Delete for everyone</button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={styles.messageTimestamp}>
                                                {formatDate(msg.createdAt)}
                                            </div>
                                        </div>
                                    ))}
                                    <div ref={bottomRef} />
                                </div>
                            </div>
                            <div className={styles.inputBox}>
                                <input
                                    type="text"
                                    value={recentMessage}
                                    onChange={(e) => setRecentMessage(e.target.value)}
                                    placeholder="Type a message..."
                                />
                                <button onClick={sendMessage4}>Send</button>
                            </div>
                     </div>
                    </div>
            )} */}
        </div>
        </>
    );
};

export default AllMessages;